export const API = process.env.REACT_APP_API_URL;

export const RESERVATIONS = process.env.REACT_APP_RESERVATIONS_URL;

export const STRIPE_DISPUTES_URL = process.env.REACT_APP_STRIPE_DISPUTES_URL;

export const OPENTABLE_CANCEL_URL = process.env.REACT_APP_OPENTABLE_CANCEL_URL;

export const ADMIN_IMAGES = process.env.REACT_APP_IMAGES_ADMINSITE_URL;